import GetPostCheckoutQuestions from '@/services/users/postCheckoutService/GetPostCheckoutQuestions';
import SaveUserPostCheckoutAnswer from '@/services/users/postCheckoutService/SaveUserPostCheckoutAnswer';

export default class PostCheckoutService {
    /**
     * Get list of post checkout questions.
     *
     * @returns {Array}
     */
    async getPostCheckoutQuestions(subscriptionId) {
        return (new GetPostCheckoutQuestions()).handle(subscriptionId);
    }

    /**
     * Save user answer for the post checkout.
     *
     * @param {String} answer
     *
     * @return {Boolean}
     */
    async saveUserPostCheckoutAnswer(answer) {
        return (new SaveUserPostCheckoutAnswer()).handle(answer);
    }
}
